/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _PackagesUtil = __webpack_require__(2);
	
	var _PackagesUtil2 = _interopRequireDefault(_PackagesUtil);
	
	var _addExperimentsFromQuery = __webpack_require__(3);
	
	var _addExperimentsFromQuery2 = _interopRequireDefault(_addExperimentsFromQuery);
	
	var _getFullRjsConfig = __webpack_require__(4);
	
	var _getFullRjsConfig2 = _interopRequireDefault(_getFullRjsConfig);
	
	var _getQueryUtils = __webpack_require__(6);
	
	var _getQueryUtils2 = _interopRequireDefault(_getQueryUtils);
	
	var _getSubdomain = __webpack_require__(7);
	
	var _getSubdomain2 = _interopRequireDefault(_getSubdomain);
	
	var _identifyForFullStory = __webpack_require__(8);
	
	var _identifyForFullStory2 = _interopRequireDefault(_identifyForFullStory);
	
	var _instrument = __webpack_require__(9);
	
	var _instrument2 = _interopRequireDefault(_instrument);
	
	var _isLocal = __webpack_require__(10);
	
	var _isLocal2 = _interopRequireDefault(_isLocal);
	
	var _joinURL = __webpack_require__(5);
	
	var _joinURL2 = _interopRequireDefault(_joinURL);
	
	var _overrideScriptsLocationMapFromQuery = __webpack_require__(11);
	
	var _overrideScriptsLocationMapFromQuery2 = _interopRequireDefault(_overrideScriptsLocationMapFromQuery);
	
	var _replaceUrlVersion = __webpack_require__(12);
	
	var _replaceUrlVersion2 = _interopRequireDefault(_replaceUrlVersion);
	
	var _requirejs = __webpack_require__(13);
	
	var _requirejs2 = _interopRequireDefault(_requirejs);
	
	var _rjsConfig = __webpack_require__(14);
	
	var _rjsConfig2 = _interopRequireDefault(_rjsConfig);
	
	var _runEditor = __webpack_require__(15);
	
	var _runEditor2 = _interopRequireDefault(_runEditor);
	
	var _storageUtil = __webpack_require__(16);
	
	var _storageUtil2 = _interopRequireDefault(_storageUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options = __webpack_require__(17); /* global window,getPloaderSantaConfig */
	
	var queryUtil = (0, _getQueryUtils2.default)(window);
	
	window.joinURL = _joinURL2.default;
	window.queryUtil = queryUtil;
	window.persistent = (0, _storageUtil2.default)(window); // TODO: how is this used?
	window.identifyForFullStory = _identifyForFullStory2.default;
	
	if (window.customRenderSite !== undefined) {
	  // allows to override this in other html files as starting points
	  window.customRenderSite();
	} else {
	  render();
	}
	
	function render() {
	  var getEditorRjsConfig = (0, _rjsConfig2.default)(window, options.versions, getPloaderSantaConfig);
	  var packagesUtil = new _PackagesUtil2.default(options.packages, window.location.search);
	
	  window.mainLoaded = Date.now();
	
	  window.serviceTopology.mediaManagerUrl = (0, _replaceUrlVersion2.default)(window.serviceTopology.mediaManagerUrl, queryUtil.getParameterByName('mmgr'));
	  window.serviceTopology.scriptsLocationMap = (0, _overrideScriptsLocationMapFromQuery2.default)(window.serviceTopology.scriptsLocationMap, queryUtil.getParameterByName('scriptsLocations'));
	
	  var editorModel = window.editorModel;
	  if (editorModel) {
	    editorModel.runningExperiments = (0, _addExperimentsFromQuery2.default)(editorModel.runningExperiments, queryUtil, 'editor');
	    editorModel.languageCode = queryUtil.getParameterByName('lang') || editorModel.languageCode;
	  }
	
	  var config = (0, _getFullRjsConfig2.default)('santa-editor', window.editorBase, getEditorRjsConfig(window.serviceTopology, editorModel, window.santaBase, _PackagesUtil2.default), packagesUtil, window.serviceTopology);
	
	  if (editorModel) {
	    editorModel.editorBase = config.baseUrl;
	    var semverMatches = config.baseUrl.match(/\/(\d+\.\d+\.\d+)\/?$/);
	    editorModel.editorVersion = semverMatches && semverMatches[1];
	
	    (0, _instrument2.default)(window, _requirejs2.default, queryUtil, editorModel);
	    window.bi.event(458, { // main-r loaded event
	      prefetch: window.afterEditorPrefetch
	    });
	  } else {
	    (0, _instrument2.default)(window, _requirejs2.default, queryUtil);
	    window.bi.event(588); // prefetch start
	  }
	
	  _requirejs2.default.config(config);
	
	  try {
	    window.document.domain = (0, _getSubdomain2.default)(window.document.domain);
	  } catch (e) {
	    // empty
	  }
	
	  if ((0, _isLocal2.default)(window.editorBase) && queryUtil.getParameterByName('hot') !== 'false') {
	    (0, _requirejs2.default)(['hot', 'jquery'], function (hot, $) {
	      hot.init($, false);
	      (0, _runEditor2.default)(window, options.packages, _requirejs2.default, editorModel, queryUtil, config);
	    });
	  } else {
	    (0, _runEditor2.default)(window, options.packages, _requirejs2.default, editorModel, queryUtil, config);
	  }
	}

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint prefer-template:0 */
	
	function PackagesUtil(packagesStructure, query) {
	  /**
	   * @param {string} str
	   * @param {string} separator
	   * @param {string} equalizer
	   * @return {Object.<String, String>}
	   */
	  function reduceStringToObject(str, separator, equalizer) {
	    return (str || '').split(separator).reduce(function (o, pairString) {
	      var pair = pairString.split(equalizer);
	      o[pair[0]] = pair[1];
	      return o;
	    }, {});
	  }
	
	  var queryParamsObject = reduceStringToObject(query.replace(/^\?/, ''), '&', '=');
	
	  /**
	   * changes the confiIg to load packages correctly, accounting the query
	   * @param {Object} config
	   * @returns {Object}
	   */
	  this.buildConfig = function (config) {
	    var debug = (queryParamsObject.debug || '').split(',').filter(Boolean);
	    if (debug.indexOf('all') !== -1) {
	      var debuggableExternals = Object.keys(config.paths).filter(function (path) {
	        return config.paths[path].source;
	      });
	      debug = packagesStructure.concat(debuggableExternals);
	    }
	
	    function isInDebug(i) {
	      return debug.indexOf(i) !== -1;
	    }
	
	    //config.paths:
	    Object.keys(config.paths).filter(function (k) {
	      return _typeof(config.paths[k]) === 'object' && !Array.isArray(config.paths[k]);
	    }).forEach(function (k) {
	      config.paths[k] = config.paths[k][isInDebug(k) ? 'source' : 'min'];
	    });
	
	    //config.bundles:
	    config.bundles = config.bundles || {};
	    packagesStructure.filter(function (pkg) {
	      return !isInDebug(pkg);
	    }).forEach(function (pkg) {
	      config.bundles[pkg] = pkg;
	      config.paths[pkg] = 'packages-bin/' + pkg + '/' + pkg + '.min';
	    });
	
	    //config.packages:
	    config.packages = config.packages || [];
	    var projectPackages = packagesStructure.filter(isInDebug).map(function (name) {
	      return {
	        name: name,
	        location: 'packages/' + name + '/src/main',
	        main: name
	      };
	    });
	    config.packages = config.packages.concat(projectPackages);
	
	    return config;
	  };
	}
	
	exports.default = PackagesUtil;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = addExperimentsFromQuery;
	/* eslint prefer-template:0 */
	
	function addExperimentsFromQuery(runningExperiments, queryUtil, project) {
	  var projValuePairRegex = new RegExp('^(' + project + ':)(.*)|(.*)$');
	
	  var experiments = {};
	  Object.keys(runningExperiments).forEach(function (key) {
	    experiments[key] = runningExperiments[key];
	  });
	
	  var setPair = function setPair(_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        value = _ref2[1];
	
	    experiments[key] = value;
	  };
	  var getValueIfProj = function getValueIfProj(str) {
	    return str.replace(projValuePairRegex, '$2');
	  };
	
	  var filterParamsForCurrProj = function filterParamsForCurrProj(paramValue) {
	    return paramValue.split(';').map(getValueIfProj).filter(Boolean).join(',');
	  };
	
	  var setParamValues = function setParamValues(param, value) {
	    var paramValue = queryUtil.getParameterByName(param);
	    if (paramValue.indexOf(':') !== -1) {
	      // Should be deprecated
	      paramValue = filterParamsForCurrProj(paramValue);
	    }
	    paramValue.split(',').filter(Boolean).map(function (exp) {
	      return [exp, value];
	    }).forEach(setPair);
	  };
	
	  var setProjParamExperiments = function setProjParamExperiments() {
	    queryUtil.getParameterByName(project + 'exp').split(',').filter(Boolean).map(function (exp) {
	      return exp.split(':');
	    }).map(function (_ref3) {
	      var _ref4 = _slicedToArray(_ref3, 2),
	          key = _ref4[0],
	          value = _ref4[1];
	
	      return [key.toLowerCase(), value || 'new'];
	    }).forEach(setPair);
	  };
	
	  //////////////////
	
	  setParamValues('experiments', 'new');
	  setParamValues('experimentsoff', 'old');
	  setProjParamExperiments();
	
	  return experiments;
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFullRjsConfig;
	
	var _joinURL = __webpack_require__(5);
	
	var _joinURL2 = _interopRequireDefault(_joinURL);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isAddress = function isAddress(str) {
	  return (/^(https?:)?\/\//.test(str)
	  );
	}; /* eslint curly:0 */
	
	function getFullRjsConfig(name, base, config, packagesUtil, serviceTopology) {
	  function getBaseUrl() {
	    if (!base) return serviceTopology.scriptsLocationMap[name];
	    if (isAddress(base)) return base;
	    return (0, _joinURL2.default)(serviceTopology.scriptsDomainUrl, 'services', name, base);
	  }
	
	  config = packagesUtil.buildConfig(config);
	  config.baseUrl = getBaseUrl();
	  return config;
	}

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint prefer-template:0 */
	
	module.exports = function joinURL() {
	  var url = arguments[0];
	  for (var i = 1; i < arguments.length; ++i) {
	    url = url.replace(/\/$/, '') + '/' + arguments[i].replace(/^\//, '');
	  }
	  return url;
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQueryUtils;
	/* eslint prefer-template:0 */
	
	function getQueryUtils(window) {
	  /**
	   * Get value of URL parameter by its name
	   * @param {string} name
	   * @param {string} query
	   * @returns {string}
	   */
	  function getParameterFromQuery(query, name) {
	    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	    var results = regex.exec(query);
	    return results && results[1] ? decodeURIComponent(results[1]).replace(/\+/g, ' ') : '';
	  }
	
	  /**
	   * Get state of boolean URL parameter by its name
	   * @param {string} name
	   * @param {string} query
	   * @returns {boolean}
	   */
	  function isParameterTrueInQuery(query, name) {
	    return getParameterFromQuery(query, name) === 'true';
	  }
	
	  return {
	    getParameterFromQuery: getParameterFromQuery,
	    isParameterTrueInQuery: isParameterTrueInQuery,
	    getParameterByName: getParameterFromQuery.bind(null, window.location.search),
	    isParameterTrue: isParameterTrueInQuery.bind(null, window.location.search)
	  };
	}

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint prefer-template:0 */
	
	module.exports = function getSubdomain(domain) {
	  if (!domain) {
	    return '';
	  }
	  var subDomain = domain.split('.');
	  if (subDomain.length <= 2) {
	    subDomain = domain;
	  } else {
	    var beforeLastPart = subDomain[subDomain.length - 2];
	    var topLevelDomains = { com: true, org: true, net: true, edu: true, gov: true, mil: true, info: true, co: true, ac: true };
	    if (topLevelDomains[beforeLastPart]) {
	      subDomain = subDomain[subDomain.length - 3] + '.' + subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
	    } else {
	      subDomain = subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
	    }
	  }
	  return subDomain;
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = identifyForFullStory;
	/* globals window */
	
	function identifyForFullStory(fullStory, editorModel) {
	  fullStory.identify(editorModel.editorSessionId, {
	    userId: editorModel.permissionsInfo.loggedInUserId,
	    userAgent: window.navigator.userAgent,
	    screenHeight: window.screen.height,
	    screenWidth: window.screen.width
	  });
	}

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = instrument;
	/* eslint prefer-template:0 */
	
	function instrument(window, requirejs, queryUtil, editorModel) {
	  editorModel = editorModel || {};
	
	  var editorVersion = editorModel.editorVersion;
	  var base = (window.serviceTopology.biServerUrl || 'http://frog.wix.com').replace(/\/$/, '');
	  var suppressbi = queryUtil.isParameterTrue('suppressbi');
	  var isDebug = queryUtil.getParameterByName('debug');
	
	  var storage = function () {
	    try {
	      var s = window.sessionStorage;
	      var test = 'ep' + Date.now();
	      s.setItem(test, test);
	      if (s.getItem(test) === test) {
	        s.removeItem(test);
	        return s;
	      }
	    } catch (e) {
	      var data = {};
	      return {
	        setItem: function setItem(k, v) {
	          data[k] = v;
	        },
	        getItem: function getItem(k) {
	          return data[k];
	        },
	        removeItem: function removeItem(k) {
	          delete data[k];
	        }
	      };
	    }
	  }();
	  if (window.isPrefetchMode) {
	    storage.setItem('afterEditorPrefetch', 'true');
	  } else {
	    window.afterEditorPrefetch = !!storage.getItem('afterEditorPrefetch');
	    storage.removeItem('afterEditorPrefetch');
	  }
	
	  var performance = window.performance;
	  if (performance && performance.mark) {
	    if (performance.setResourceTimingBufferSize) {
	      if ('onresourcetimingbufferfull' in performance) {
	        performance.onresourcetimingbufferfull = function () {
	          var maxSize = 150;
	          return function () {
	            maxSize *= 2;
	            performance.setResourceTimingBufferSize(maxSize);
	          };
	        }();
	      } else {
	        performance.setResourceTimingBufferSize(isDebug ? 1000 : 300);
	      }
	    }
	    performance.mark('main-r loaded');
	  }
	
	  function getCookie(name) {
	    var re = new RegExp('(?:^|\\W)' + name + '\s*=([^;]*)');
	    var m = window.document.cookie.match(re);
	    return m ? m[1].trim() : m;
	  }
	
	  var permissionInfo = editorModel.permissionsInfo || {};
	  var implicitParams = function () {
	    var implicitFields = {
	      ownerId: function ownerId() {
	        return permissionInfo.ownerId || '';
	      },
	      roles: function roles() {
	        var loggedInUserRoles = (permissionInfo.loggedInUserRoles || []).map(function (loggedInUserRole) {
	          return loggedInUserRole.role;
	        }).join();
	        this.roles = function () {
	          return loggedInUserRoles;
	        };
	        return this.roles();
	      },
	      esi: function esi() {
	        return editorModel.editorSessionId || '';
	      },
	      did: function did() {
	        return window.siteId || '';
	      },
	      msid: function msid() {
	        return editorModel.metaSiteId || '';
	      },
	      ts: function ts(now) {
	        return now - (window.mainLoaded || 0);
	      },
	      c: function c(now) {
	        return now;
	      }
	    };
	
	    var newrelic = window.newrelic;
	    if (newrelic) {
	      if (newrelic.setCustomAttribute) {
	        newrelic.setPageViewName(window.location.href.replace(/^[^/]*\/\//, ''));
	
	        var roles = implicitFields.roles();
	        if (roles) {
	          newrelic.setCustomAttribute('roles', roles);
	        }
	        newrelic.setCustomAttribute('esi', implicitFields.esi());
	        newrelic.setCustomAttribute('did', implicitFields.did());
	        newrelic.setCustomAttribute('msid', implicitFields.msid());
	        newrelic.setCustomAttribute('prefetch', window.afterEditorPrefetch);
	        if (editorVersion) {
	          newrelic.setCustomAttribute('editorVersion', editorVersion);
	        }
	
	        // Running experiments:
	        var runningExperiments = editorModel.runningExperiments;
	        if (runningExperiments) {
	          var runningExperimentKeys = Object.keys(runningExperiments).filter(function (key) {
	            return runningExperiments[key] !== 'old';
	          }).map(function (experimentName) {
	            var experimentValue = runningExperiments[experimentName];
	            return experimentValue !== 'new' ? experimentName + '=' + experimentValue : experimentName;
	          }).join('][');
	          if (runningExperimentKeys) {
	            newrelic.setCustomAttribute('experiments', '[' + runningExperimentKeys + ']');
	          }
	        }
	      }
	      if (!suppressbi && editorVersion && newrelic.addPageAction) {
	        newrelic.addPageAction('main-r loaded');
	      }
	    }
	
	    return function () {
	      var size = 0;
	      var now = Date.now();
	      var payload = Object.keys(implicitFields).map(function (key) {
	        var result = key + '=' + implicitFields[key](now);
	        size += result.length;
	        return result;
	      });
	      payload.size = size;
	      return payload;
	    };
	  }();
	
	  function sendBI(reportDef, params) {
	    var payload = implicitParams();
	
	    var size = payload.size;
	    params = Object.keys(params || {}).map(function (key) {
	      var value = params[key];
	      if (typeof value === 'string') {
	        if (size + value.length > 1536) {
	          value = value.substring(0, Math.max(1536 - size, 32));
	        }
	        value = encodeURIComponent(value);
	      }
	      var result = key + '=' + value;
	      size += result.length;
	      return result;
	    });
	    payload = params.concat(payload);
	
	    var endpoint = reportDef.endpoint || 'editor';
	    var evid = reportDef.evid;
	    var src = reportDef.src || 38;
	    payload = payload.length ? '&' + payload.join('&') : '';
	
	    var srcBI = base + '/' + endpoint + '?evid=' + evid + '&src=' + src + '&majorVer=3&viewMode=editor' + payload;
	    if (suppressbi) {
	      window.console.log('BI:', srcBI);
	    } else {
	      new window.Image().src = srcBI;
	    }
	  }
	
	  var bi = {
	    event: function event(reportDef, params) {
	      if (typeof reportDef === 'number') {
	        reportDef = {
	          evid: reportDef
	        };
	      }
	      sendBI(reportDef, params);
	    },
	
	    error: function () {
	      var errorSeverityMap = {
	        recoverable: 10,
	        warning: 20,
	        error: 30,
	        fatal: 40
	      };
	      return function (reportDef, params) {
	        params = params || {};
	        var rd = {
	          evid: 10,
	          endpoint: reportDef.endpoint || 'trg'
	        };
	        var p = {
	          errn: reportDef.errorName,
	          errc: reportDef.errorCode,
	          sev: errorSeverityMap[reportDef.severity] || reportDef.severity,
	          cat: 1,
	          iss: 1
	        };
	        var ut = getCookie('userType');
	        if (ut) {
	          p.ut = ut;
	        }
	        Object.keys(params).forEach(function (param) {
	          p[param] = params[param];
	        });
	        sendBI(rd, p);
	      };
	    }()
	  };
	  window.bi = bi;
	
	  if ((isDebug || suppressbi || !editorVersion) && !queryUtil.isParameterTrue('bi')) {
	    return;
	  }
	
	  var _sendErrorOnce = function sendErrorOnce(errorName, errorCode, severity) {
	    //eslint-disable-line func-style
	    _sendErrorOnce = function sendErrorOnce() {}; // only report one error per session
	    var params = Array.prototype.slice.call(arguments, 3).reduce(function (result, arg, index) {
	      result['p' + (index + 1)] = arg;
	      return result;
	    }, {});
	    bi.error({
	      errorName: errorName,
	      errorCode: errorCode,
	      severity: severity
	    }, params);
	  };
	
	  var origOnError = window.onerror || function () {};
	  window.onerror = function (errorMsg, url, line, column, err) {
	    var where = err && typeof err.stack === 'string' ? err.stack : url;
	    _sendErrorOnce('JAVASCRIPT_ERROR', 111022, 'fatal', errorMsg, where, line, column);
	    return origOnError.apply(this, arguments);
	  };
	
	  if (window.console) {
	    var origError = window.console.error;
	    if (origError) {
	      window.console.error = function () {
	        _sendErrorOnce.bind(null, 'CONSOLE_ERROR', 111023, 'error').apply(null, arguments);
	        return origError.apply(this, arguments);
	      };
	    }
	  }
	
	  var origRjsError = requirejs.onError || function () {};
	  requirejs['onError'] = function (err) {
	    // eslint-disable-line dot-notation
	    // because ajv requires js-beautify synchronously even if does not use
	    if (err.message && err.message.indexOf && err.message.indexOf('Module name "js-beautify" has not been loaded yet') === 0) {
	      return;
	    }
	    var modules = (err.requireModules || []).join(';');
	    var where = typeof err.stack === 'string' ? err.stack : '';
	    var errn = err.errn || 'REQUIREJS_ERROR';
	    var errc = err.errc || 111024;
	    var severity = err.severity || 'fatal';
	    _sendErrorOnce(errn, errc, severity, err.message, modules, where);
	    return origRjsError.apply(this, arguments); // eslint-disable-line consistent-return
	  };
	}

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLocal;
	function isLocal(path) {
	  return (/^(https?:)?\/\/localhost($|[/:])/.test(path)
	  );
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = overrideScriptsLocationMapFromQuery;
	
	var _replaceUrlVersion = __webpack_require__(12);
	
	var _replaceUrlVersion2 = _interopRequireDefault(_replaceUrlVersion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function overrideScriptsLocationMapFromQuery(scriptsLocationMap, overrideParam) {
	  overrideParam.split(',').filter(Boolean).forEach(function (keyValueString) {
	    var pair = keyValueString.split(':');
	    var urlOverride = (0, _replaceUrlVersion2.default)(scriptsLocationMap[pair[0]], pair[1]);
	    if (urlOverride && scriptsLocationMap[pair[0]] !== urlOverride) {
	      scriptsLocationMap[pair[0]] = urlOverride;
	    }
	  });
	  return scriptsLocationMap;
	}

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var bareSemver = /(\d)+\.(\d)+\.(\d)+/;
	var onlyBareSemver = /^(\d)+\.(\d)+\.(\d)+$/;
	var onlySha = /^[0-9a-f]{40}$/;
	
	var validVersion = function validVersion(version) {
	  return onlyBareSemver.test(version) || onlySha.test(version);
	};
	
	function replaceUrlVersion(url, version) {
	  return url && validVersion(version) ? url.replace(bareSemver, version) : url;
	}
	
	exports.default = replaceUrlVersion;

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = requirejs;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (window, versions, getPloaderSantaConfig) {
	  function getEditorRjsConfig(serviceTopology, editorModel, baseVersion, PackagesUtil) {
	    // eslint-disable-line no-unused-vars
	    var langsLocation = serviceTopology && serviceTopology.scriptsLocationMap['santa-langs'] || 'http://static.parastorage.com/services/santa-langs/1.194.0';
	    var languageCode = editorModel && editorModel.languageCode || 'en';
	    var langsUrl = (0, _joinURL2.default)(langsLocation, 'resources/santa-editor/bundles/_generated/santa_editor_' + languageCode + '.json');
	    if (langsUrl.indexOf('http:') === 0) {
	      langsUrl = [langsUrl, langsUrl.replace(/http/, 'https')];
	    }
	
	    var tpaGfppDataUrl = serviceTopology && serviceTopology.scriptsLocationMap['tpa-gfpp-data'] || 'http://static.parastorage.com/services/tpa-gfpp-data/1.5.0';
	    var mmgrBaseUrl = serviceTopology ? serviceTopology.mediaManagerUrl : 'http://editor.wix.com/static/services/media-gallery-g5/1.81.0/';
	    var scriptLocation = serviceTopology && serviceTopology.scriptsDomainUrl || 'http://static.parastorage.com/';
	    var thirdParty = _joinURL2.default.bind(null, scriptLocation, 'services', 'third-party');
	    var ckeditor = _joinURL2.default.bind(null, scriptLocation, 'services', 'ck-editor');
	
	    var basePublicUrl = serviceTopology.basePublicUrl || 'http://www.wix.com';
	    var santaIde = _joinURL2.default.bind(null, basePublicUrl, '_partials', 'santa-ide');
	
	    var getIntegrationPath = function getIntegrationPath(app) {
	      var packageName = app + 'IntegrationEditor';
	      if ((0, _isLocal2.default)(window.editorBase)) {
	        return 'http://localhost:4578/' + packageName + '/src/main';
	      }
	      return 'http://s3.amazonaws.com/integration-tests-statics/SNAPSHOT/runners/' + packageName + '/src/main';
	    };
	
	    return {
	      baseUrl: '',
	      paths: {
	        lodash: thirdParty('lodash/' + versions.lodash + '/lodash.min'),
	        jquery: thirdParty('jquery/2.1.1/dist/jquery.min'),
	        zepto: thirdParty('zepto/1.2.0/zepto.min'),
	        ckeditor: ckeditor('1.223.0/ckeditor'),
	        wixmp: (0, _joinURL2.default)(serviceTopology.scriptsLocationMap['wixmp-sdk'], 'wixmp-sdk.amd'),
	        color: thirdParty('color-convert/0.2.0/color.min'),
	        speakingurl: thirdParty('speakingurl/speakingurl.min'),
	        keyboardMaster: {
	          min: thirdParty('keymaster/1.6.3/keymaster.min'),
	          source: thirdParty('keymaster/1.6.3/keymaster')
	        },
	        react: {
	          min: thirdParty('react/' + versions.react + '/react-with-addons.min'),
	          source: '//cdnjs.cloudflare.com/ajax/libs/react/' + versions.react + '/react-with-addons'
	        },
	        reactDOM: {
	          min: thirdParty('react/' + versions.react + '/react-dom.min'),
	          source: '//cdnjs.cloudflare.com/ajax/libs/react/' + versions.react + '/react-dom'
	        },
	        langs: langsUrl,
	        mediaFrame: (0, _joinURL2.default)(mmgrBaseUrl, 'scripts/media-frame'),
	        aviary: thirdParty('aviary/3.1.0.243/js/feather'),
	        facebook: ['//connect.facebook.net/en_US/all', 'js/vendor/facebook/facebook.min'],
	        pms: 'js/modules/PMS',
	        jasmine: thirdParty('jasmine/2.1.3/jasmine'),
	        'jasmine-html': thirdParty('jasmine/2.1.3/jasmine-html'),
	        'jasmine-boot': thirdParty('jasmine/2.1.3/jasmine-boot'),
	        bluebird: thirdParty('bluebird/2.9.4/bluebird.min'),
	        plugins: 'js/plugins/bundle/plugins.bundle',
	        santaIde: {
	          min: santaIde(versions.santaIde + '/code_edit/built-codeEdit.min'),
	          source: santaIde(versions.santaIde + '/code_edit/built-codeEdit')
	        },
	        redux: {
	          min: thirdParty('redux/3.0.5/redux.min'),
	          source: thirdParty('redux/3.0.5/redux')
	        },
	        'react-redux': {
	          min: thirdParty('react-redux/4.4.5/react-redux.min'),
	          source: thirdParty('react-redux/4.4.5/react-redux')
	        },
	        'redux-immutablejs': thirdParty('redux-immutablejs/0.0.7/redux-immutablejs.min'),
	        immutable: {
	          min: thirdParty('immutable/3.7.5/dist/immutable.min'),
	          source: thirdParty('immutable/3.7.5/dist/immutable')
	        },
	        ReactProxy: 'js/vendor/ReactProxy',
	        io: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.4.0/socket.io.min',
	        hot: '../node_modules/santa-utils/common/hot/listener',
	        'wix-fullstory-loader': './node_modules/wix-fullstory-loader/dist/statics/app.bundle',
	        patcher: '../node_modules/santa-utils/common/hot/patcher',
	        pmrpc: thirdParty('pm-rpc/1.0.3/pm-rpc.min'),
	        tpaGfppData: (0, _joinURL2.default)(tpaGfppDataUrl, '/data/tpa-gfpp-data.min'),
	        baseUILib: 'node_modules/wix-base-ui/dist/base-ui',
	        wixRichText: {
	          min: './node_modules/wix-richtext/dist/bundleWixRichText',
	          source: './node_modules/wix-richtext/debug/bundleWixRichText'
	        },
	        TweenMax: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/TweenMax.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/TweenMax') },
	        TweenLite: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/TweenMax.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/TweenMax') },
	        TimelineMax: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/TweenMax.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/TweenMax') },
	        ScrollToPlugin: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/plugins/ScrollToPlugin.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/plugins/ScrollToPlugin') },
	        DrawSVGPlugin: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/plugins/DrawSVGPlugin.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/plugins/DrawSVGPlugin') },
	        MorphSVGPlugin: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/plugins/MorphSVGPlugin.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/plugins/MorphSVGPlugin') },
	        Draggable: { min: thirdParty('tweenmax/' + versions.tweenmax + '/minified/utils/Draggable.min'), source: thirdParty('tweenmax/' + versions.tweenmax + '/uncompressed/utils/Draggable') },
	        addPanelSectionsDA: './node_modules/editor-add-panel/dist/addPanelSectionsDA',
	        addPanelSectionsDE: './node_modules/editor-add-panel/dist/addPanelSectionsDE',
	        addPanelSectionsEN: './node_modules/editor-add-panel/dist/addPanelSectionsEN',
	        addPanelSectionsES: './node_modules/editor-add-panel/dist/addPanelSectionsES',
	        addPanelSectionsFR: './node_modules/editor-add-panel/dist/addPanelSectionsFR',
	        addPanelSectionsIT: './node_modules/editor-add-panel/dist/addPanelSectionsIT',
	        addPanelSectionsJA: './node_modules/editor-add-panel/dist/addPanelSectionsJA',
	        addPanelSectionsKO: './node_modules/editor-add-panel/dist/addPanelSectionsKO',
	        addPanelSectionsNL: './node_modules/editor-add-panel/dist/addPanelSectionsNL',
	        addPanelSectionsNO: './node_modules/editor-add-panel/dist/addPanelSectionsNO',
	        addPanelSectionsPL: './node_modules/editor-add-panel/dist/addPanelSectionsPL',
	        addPanelSectionsPT: './node_modules/editor-add-panel/dist/addPanelSectionsPT',
	        addPanelSectionsRU: './node_modules/editor-add-panel/dist/addPanelSectionsRU',
	        addPanelSectionsSV: './node_modules/editor-add-panel/dist/addPanelSectionsSV',
	        addPanelSectionsTR: './node_modules/editor-add-panel/dist/addPanelSectionsTR',
	        coreUtilsLib: 'node_modules/santa-core-utils/dist/coreUtils',
	        imageClientApi: 'node_modules/santa-core-utils/dist/imageClientApi',
	        wixImmutable: 'node_modules/santa-core-utils/dist/wixImmutable',
	        'ag-grid': { min: thirdParty('ag-grid/6.2.1/dist/ag-grid.min'), source: thirdParty('ag-grid/6.2.1/dist/ag-grid') }
	      },
	      packages: [{
	        name: 'platformIntegrationEditor',
	        main: 'platformIntegrationEditor',
	        location: getIntegrationPath('platform')
	      }, {
	        name: 'uiLibIntegrationEditor',
	        main: 'uiLibIntegrationEditor',
	        location: getIntegrationPath('uiLib')
	      }, {
	        name: 'tpaIntegrationEditor',
	        main: 'tpaIntegrationEditor',
	        location: getIntegrationPath('tpa')
	      }],
	      bundles: {
	        plugins: ['json', 'domReady', 'experiment', 'pLoader']
	      },
	      shim: {
	        color: { exports: 'Color' },
	        lodash: { exports: '_' },
	        jquery: { exports: '$' },
	        keyboardMaster: { exports: 'key' },
	        mediaFrame: { exports: 'MediaFrame', deps: ['jquery'] },
	        aviary: { exports: 'featherEditor' },
	        facebook: { exports: 'FB' },
	        'jasmine-html': { deps: ['jasmine'] },
	        'jasmine-boot': { deps: ['jasmine', 'jasmine-html'] },
	        bluebird: { exports: 'bluebird' },
	        ReactProxy: {
	          deps: ['react'],
	          exports: 'ReactProxy'
	        }
	      },
	      map: {
	        '*': {
	          'react/addons': 'react'
	        }
	      },
	      pLoader: {
	        santa: getPloaderSantaConfig(serviceTopology, baseVersion, PackagesUtil)
	      },
	      jsx: {
	        baseDefines: { lodash: '_', react: 'React' },
	        fileExtension: '.html'
	      },
	      waitSeconds: 0
	    };
	  }
	
	  return getEditorRjsConfig;
	};
	
	var _isLocal = __webpack_require__(10);
	
	var _isLocal2 = _interopRequireDefault(_isLocal);
	
	var _joinURL = __webpack_require__(5);
	
	var _joinURL2 = _interopRequireDefault(_joinURL);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = runEditor;
	/* eslint lodash/prefer-includes:0,no-extra-parens:0,prefer-template:0,func-style:0 */
	
	function runEditor(window, packagesStructure, requirejs, editorModel, queryUtil, config) {
	  var packagesArr = ['symbols', 'addPanelData', 'rEditor', 'compPanels', 'core', 'wixStore', 'tpa', 'util', 'blog', 'wixBookings', 'jquery', 'react', 'reactDOM', 'lodash', 'aviary', 'superAppMenuInfra', 'savePublish', 'panels', 'addPanelInfra', 'experiment', 'staticAssets', 'pLoader', 'textControls', 'mediaFrame', 'keyboardMaster', 'baseUI', 'uiAnimations', 'panelUtils', 'mediaServices', 'color', 'pms', 'databaseEditor', 'json', 'gfppData', 'backgroundPresets', 'styles', 'pagesMenu', 'userPreferences', 'popups', 'pLoader!santa:skins', 'pLoader!santa:documentServices', 'addPanelSections', 'addPanelDataConsts', 'addPanelSectionsEN'];
	
	  if (queryUtil.isParameterTrue('isqa')) {
	    packagesArr.push('pLoader!santa:qaAutomation', 'debugTools');
	  }
	  if (queryUtil.isParameterTrue('isTpaIntegration')) {
	    packagesArr.push('tpaIntegrationEditor', 'jasmine', 'jasmine-html', 'bluebird');
	  }
	  if (queryUtil.isParameterTrue('isUiLibIntegration')) {
	    packagesArr.push('uiLibIntegrationEditor', 'jasmine', 'jasmine-html', 'bluebird');
	  }
	  if (queryUtil.isParameterTrue('isPlatformIntegration')) {
	    packagesArr.push('platform', 'platformIntegrationEditor', 'jasmine', 'jasmine-html', 'bluebird');
	  }
	
	  var languageCode = window.editorModel && window.editorModel.languageCode;
	  var languagePackageName = languageCode && 'addPanelSections' + languageCode.toUpperCase();
	  var existsInPackagesStructure = packagesStructure.indexOf(languagePackageName) !== -1;
	  var isSupportedAddPanelLanguage = !!config.paths[languagePackageName];
	  if (!existsInPackagesStructure && isSupportedAddPanelLanguage) {
	    packagesArr.push(languagePackageName);
	  }
	
	  var prefetch = window.isPrefetchMode || window.location.pathname.indexOf('prefetch') > 0 || queryUtil.isParameterTrue('prefetch');
	
	  // Preload scripts for caching
	  var onError = errorHandler;
	  if (prefetch && window.define) {
	    onError = function onError() {};
	    var plugins = {
	      pLoader: true,
	      json: true,
	      text: true,
	      experiment: true
	    };
	    var dummy = function dummy() {
	      return {};
	    };
	    var define = window.define;
	    window.define = function (name) {
	      var args = Array.apply(null, arguments);
	      if (!plugins.hasOwnProperty(name) && name !== 'jquery') {
	        for (var i = 1; i < args.length; ++i) {
	          if (typeof args[i] === 'function') {
	            args[i] = dummy;
	          }
	        }
	      }
	      return define.apply(this, args);
	    };
	    window.define.amd = define.amd;
	  }
	
	  requirejs(packagesArr, function () {
	    if (prefetch) {
	      window.bi.event(589); // prefetch finished
	      return;
	    }
	
	    function buildFunctionParametersObject(_pkgs, args) {
	      return _pkgs.reduce(function (result, pkg, index) {
	        result[pkg.replace(/^.*:/, '')] = args[index];
	        return result;
	      }, {});
	    }
	    var p = buildFunctionParametersObject(packagesArr, arguments);
	
	    if (languagePackageName) {
	      p.addPanelSections.applyTranslatedSections(p[languagePackageName]);
	    }
	
	    p.rEditor.editorMain.start(p);
	  }, onError);
	
	  function errorHandler(err) {
	    if (!config.urlArgs) {
	      if (err.requireModules) {
	        err.requireModules.forEach(function (module) {
	          requirejs.undef(module);
	        });
	      }
	      config.urlArgs = 'c=' + Date.now();
	      requirejs.config(config);
	      requirejs(packagesArr, function () {
	        err.errn = 'REQUIREJS_RETRY_ERROR';
	        err.errc = 111025;
	        err.severity = 10;
	        requirejs.onError(err);
	      }, function (error) {
	        requirejs.onError(error);
	      });
	    }
	  }
	}

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (window) {
	  function isAvailable(name) {
	    try {
	      var unique = 'testStorage' + Date.now();
	      var st = window[name];
	      st.setItem(unique, unique);
	      var value = st.getItem(unique);
	      st.removeItem(unique);
	      if (value !== unique) {
	        throw 'not equal'; //eslint-disable-line no-throw-literal
	      }
	    } catch (e) {
	      return false;
	    }
	    return true;
	  }
	
	  var storage = void 0;
	  if (isAvailable('localStorage')) {
	    storage = window.localStorage;
	  } else if (isAvailable('sessionStorage')) {
	    storage = window.sessionStorage;
	  } else {
	    storage = {
	      setItem: function setItem() {},
	      getItem: function getItem() {},
	      removeItem: function removeItem() {}
	    };
	  }
	
	  return {
	    save: function save(key, value) {
	      storage.setItem(key, value);
	    },
	    load: function load(key) {
	      return storage.getItem(key);
	    },
	    remove: function remove(key) {
	      storage.removeItem(key);
	    }
	  };
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = {
		"versions": {
			"lodash": "4.17.4/dist",
			"react": "0.14.3",
			"pmrpc": "1.30.0",
			"tweenmax": "1.19.0",
			"santaIde": "1.83.0"
		},
		"packages": [
			"addPanelData",
			"addPanelDataConsts",
			"addPanelInfra",
			"addPanelSections",
			"advancedStylePanel",
			"backgroundPresets",
			"baseUI",
			"blog",
			"boxSlideshow",
			"columnsControls",
			"compPanels",
			"constants",
			"core",
			"customizeDesignDataPanel",
			"databaseEditor",
			"debugTools",
			"designPanel",
			"designPanelUtils",
			"editorEventRegistry",
			"editorHints",
			"firstTimeExperience",
			"firstTimePanelsComponents",
			"gfppData",
			"helpIds",
			"higherOrderComponents",
			"imageCrop",
			"mediaServices",
			"mobileEditor",
			"pagesMenu",
			"panelUtils",
			"panels",
			"platform",
			"platformPanels",
			"popups",
			"rEditor",
			"santaPreview",
			"savePublish",
			"shoutOut",
			"staticAssets",
			"styles",
			"superAppMenuInfra",
			"symbols",
			"testUtils",
			"textControls",
			"tpa",
			"tpaPanels",
			"uiAnimations",
			"uiConstants",
			"userPreferences",
			"util",
			"videoSearch",
			"wixBookings",
			"wixCode",
			"wixStore"
		]
	};

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// main-r.min.js